import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class StrapiService {

  public strapUrl = environment.strapiUrl;
  public JWTToken = environment.strapiJWTToken;

  constructor(

    private _http: HttpClient
  ) { }

  /**
    * Get Auth Screen details
  */
  public getAuthScreenContent(): Observable<object> {

    // returns image and the SS logo
    return this._http.get(`${this.strapUrl}/sign-up-screen-image?populate[image][fields][1]=url&populate[logo][fields][1]=url`);
  }

  /**
    * Get T&C Screen details
  */
  public getTermsAndConditionsScreenContent(): Observable<object> {

    // returns image and the SS logo
    return this._http.get(`${this.strapUrl}/terms-and-conditions?populate=*`);
  }

  /**
    * Get T&C Screen details
  */
    public getTermsAndConditionsCategories(): Observable<object> {

      // returns all terms and conditions categories
      return this._http.get(`${this.strapUrl}/terms-and-conditions-categories?populate=*`);
    }


   /**
    * Get Privacy Policy Screen details
  */
   public getPrivacyPolicyScreenContent(): Observable<object> {

    // returns image and the SS logo
    return this._http.get(`${this.strapUrl}/terms-and-conditions?populate=*`);
  }


  /**
    * Get Contact us Screen details
  */
  public getContactUsScreenContent(): Observable<object> 
  {
    // replace Agility JWT with Strap JWT
    return this._http.get(`${this.strapUrl}/contact-us-page?fields[0]=text&populate[image][fields][1]=url&populate[headerImage][fields][1]=url&populate[mobileImage][fields][2]=url`);
  }

  /**
    * Get Complaints Screen details
  */
  public getComplaintsScreenContent(): Observable<object> 
  {
    // replace Agility JWT with Strap JWT
    return this._http.get(`${this.strapUrl}/complaints-page-header?populate[image][fields][1]=url&populate[mobileImage][fields][2]=url&populate[terms_and_conditions]=*&populate[pdf]=*`);
  }

  /**
    * Get Contact us Screen details
  */
  public getAboutUsScreenContent(): Observable<object> {

    // returns image and the SS logo
    return this._http.get(`${this.strapUrl}/about-us-pages?populate[image][fields][1]=url&populate[image][fields][2]=alternativeText`);
  }

  /**
    * Get Contact us Screen details
  */
  public getAboutUsHeaderContent(): Observable<object> {

    // returns image and the SS logo
    return this._http.get(`${this.strapUrl}/about-us-page-header?populate[image][fields][1]=url&populate[mobileImage][fields][2]=url`);
  }

  /**
    * Get Home Page Header Content
  */
  public getHomeHeaderContent(): Observable<object> {

    // returns image and the SS logo
    return this._http.get(`${this.strapUrl}/home-page-header?fields[0]=headerText&populate[image][fields][1]=url&fields[1]=bodyText&fields[2]=text_color_hex&populate[mobileImage][fields][3]=url`);
  }

  /**
    * Get Home Page Body Content
  */
  public getHomeBodyContent(): Observable<object> {

    // returns image and the SS logo
    return this._http.get(`${this.strapUrl}/home-page-body?populate=*`);
    // return this._http.get(`${this.strapUrl}/home-page-body?fields[0]=banner_body&fields[1]=banner_header&fields[2]=learn_more_title&fields[3]=learn_more_text&fields[4]=text_color_hex`);
  }

  /**
  * Get Home Faq Body Content
  */
  public getFaqsByCategory(): Observable<object> {

    // returns body
    return this._http.get(`${this.strapUrl}/faqs?&populate=*`);
  }


   /**
  * Get Support Page Header
  */
   public getSupportPageHeader(): Observable<object> 
   {
     // replace Agility JWT with Strap JWT
     let headers = new HttpHeaders;
     headers = headers.set('Authorization', this.JWTToken);

     // returns body
     return this._http.get(`${this.strapUrl}/support-page-header?populate=*`, {headers});
   }

   /**
  * Get Support Body Content
  */
  public getSupportPageScreenContent(): Observable<object> {

    // return this._http.get(`${this.strapUrl}/supports?populate=*`);
    return this._http.get(`${this.strapUrl}/supports?fields[0]=topic&fields[1]=renderPriority&populate[icon][fields][1]=url&populate[support_category][fields][0]=categoryTitle`);
  }

   /**
  * Get Support Body Content
  */
  public getSupportPageScreenContentById(id): Observable<object> {

    // returns body
    return this._http.get(`${this.strapUrl}/supports/${id}?populate=*`);
  }
  

  
   /**
  * Get Home Faq Body Content
  */
   public getHelpPageHeaderContent(): Observable<object>
   {
     // replace Agility JWT with Strap JWT
     let headers = new HttpHeaders;
     headers = headers.set('Authorization', this.JWTToken);
 
     // returns body
     return this._http.get(`${this.strapUrl}/help-page-header?&populate=*`, {headers});
   }


  /**
  * Get Home Faq Body Content
  */
  public getProductsFaqsByCategory(): Observable<object> {

    // returns body
    return this._http.get(`${this.strapUrl}/faqs?filters[FaqCategory][Title][$eq]=Products`);
  }

  

  /**
  * Get Home Faq Body Content
  */
  public getHelpPageScreenContent(): Observable<object> {

    // returns body
    return this._http.get(`${this.strapUrl}/helps`);
  }

  /**
  * Get Catalog Screen Content
  */
  public getCatalogScreenContent() {

    // returns catalog
    return this._http.get(`${this.strapUrl}/catalog-page-contents?populate[image][fields][1]=url&populate[image][fields][2]=alternativeText`);
  }

  /**
  * Get Catalog Screen Header Content
  */
  public getCatalogScreenHeaderContent() {

    // returns image and the SS logo
    return this._http.get(`${this.strapUrl}/catalog-page-header?populate[image][fields][1]=url&populate[mobileImage][fields][2]=url`);
  }


    /**
    * Get Deals Screen Header Content
    */
    public getDealsScreenHeaderContent() {
   
      // returns image and the SS logo
      return this._http.get(`${this.strapUrl}/deals-page-header?populate[image][fields][1]=url`);
    }
  
   

  /**
  * Get Catalog Screen Content
  */
    public getPartnerLogos() {

      // returns catalog
      return this._http.get(`${this.strapUrl}/partner-logo?populate[logos][fields][1]=url&populate[logos][fields][2]=alternativeText`);
    }

  /**
  * Get Product Faq Body Content
  */
  public GetProductsContent(): Observable<object> {

    // returns body
    return this._http.get(`${this.strapUrl}/products?populate[headerImage][fields][1]=url&populate[fallbackImage][fields][2]=url&populate[mobileImage][fields][3]=url`);
  }

   /**
  * Get Provinces
  */
   public GetProvinces(): Observable<object> {

    // returns body
    return this._http.get(`${this.strapUrl}/provinces?populate=*`);
  }

  /**
    * Get Packages Screen details
  */
  public getPackagesScreenContent() 
  {

    // returns image and the SS logo
    return this._http.get(`${this.strapUrl}/service-types`);
  }

   /**
    * Get Packages Screen details
  */
   public getNetworkStatus() 
   {
        // replace Agility JWT with Strap JWT
        let headers = new HttpHeaders;
        headers = headers.set('Authorization', this.JWTToken);
        return this._http.get(`${this.strapUrl}/network-statuses?populate[Provider][populate][logo][fields][0]=url&populate[Province][populate]=*&populate[Product][populate][logo][fields][0]=url&populate[Impact][populate]=*&populate[Type][populate]=*&populate[Status][populate]=*`,{headers});
   }

   /**
    * Get Blogs
  */
   public getBlogs(blogId?) 
   {
        // replace Agility JWT with Strap JWT
        let headers = new HttpHeaders;
        headers = headers.set('Authorization', this.JWTToken);
        var url = "blogs?populate[image][fields][1]=url";
        if (blogId) url += `&filters[id][$eq]=${blogId}`
        return this._http.get(`${this.strapUrl}/${url}`,{headers});
   }


  /**
    * Get Home Page Header Content
  */
  public getHomePageReasons(): Observable<object> {
    // returns image and the SS logo
    return this._http.get(`${this.strapUrl}/home-page-reasons?populate[icon][fields][1]=url&populate[icon][fields][2]=alternativeText`);
  }


  public getHomePageBanners(): Observable<object> {
    // returns image and the SS logo
    return this._http.get(`${this.strapUrl}/home-page-banners?populate[banner][fields][1]=url&populate[mobileBanner][fields][2]=alternativeText&populate[mobileBanner][fields][3]=url`);
  }


  public getDealImages(): Observable<object> {
    // returns image and the SS logo
    return this._http.get(`${this.strapUrl}/deal-card-images?populate=*&pagination[limit]=200`);
  }

  public getDealPageBanners(): Observable<object> {
    // returns image and the SS logo
    return this._http.get(`${this.strapUrl}/deal-page-banners?populate=*`);
  }

    public getCampaign(): Observable<object> {
      return this._http.get(`${this.strapUrl}/campaign-page?populate=*`);
  }


}
